import { StaticImage } from "gatsby-plugin-image"

import { Icon } from "@trueskin-web/components"
import { quoteIcon } from "@trueskin-web/theme/icons/quoteIcon"

const TestimonialCard = ({
  quote,
  authorName,
  authorTitle,
  className,
  ...props
}) => (
  <div
    className={className}
    sx={{
      width: ["100vw", "100%"],
      position: "relative",
      left: ["50%", 0],
      mr: [null, "auto"],
      mb: 4,
      ml: ["-50vw", 0],
      bg: "#1A1C2B",
      borderRadius: "32px",
      overflow: "hidden",
      color: "#FFF",
      textAlign: "center",
    }}
    {...props}
  >
    <div sx={{ pt: 5, px: 5 }}>
      <div
        sx={{
          width: "100%",
          height: ["200px", "250px"],
          overflow: "hidden",
        }}
      >
        <StaticImage
          src="../images/testimotional-card-doctor.webp"
          alt={authorName}
          placeholder="none"
          style={{
            borderRadius: "8px",
            width: "100%",
            height: "100%",
          }}
        />
      </div>
    </div>

    <div sx={{ px: 5, py: 5 }}>
      <div sx={{ justifyContent: "center", mb: 3, mt: -4 }}>
        <Icon icon={quoteIcon} sx={{ opacity: 0.5 }} width={25} height={18} />
      </div>
      <p sx={{ fontSize: 1, lineHeight: 1.428, mb: 4 }}>{quote}</p>
      <p sx={{ fontSize: 0, opacity: 0.5, m: 0 }}>{authorName}</p>
      <p sx={{ fontSize: 0, opacity: 0.5, m: 0 }}>{authorTitle}</p>
    </div>
  </div>
)

export default TestimonialCard
